/* Cast & Cabin storefront script. Same behavior as the design mockup, wired to Shopify's Ajax Cart API.
   VIP model: every gift has a "Price" option (Guest / VIP). Joining VIP adds the VIP Membership product
   (sold with a Shopify Subscriptions plan) and switches every gift in the cart to its VIP variant. */
(function(){
  const CC=window.CC||{};
  const $=s=>document.querySelector(s);
  const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  function money(cents){
    const fmt=CC.moneyFormat||'${{amount}}';
    const v=(Number(cents)||0)/100;
    const a=v.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,(m,k)=>k==='amount_no_decimals'?Math.round(v).toLocaleString('en-US'):k==='amount_with_comma_separator'?a.replace('.',','):a);
  }
  const fmtDate=d=>d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
  const addDays=(d,n)=>{const x=new Date(d);x.setDate(x.getDate()+n);return x;};
  // delivery estimates count business days (Mon-Fri), like Shopify's checkout dates
  const addBiz=(d,n)=>{const x=new Date(d);while(n>0){x.setDate(x.getDate()+1);const w=x.getDay();if(w!==0&&w!==6)n--;}return x;};
  const P=CC.products||{};
  const VIP=CC.vip||{};
  const PROTECT=CC.protect||{};
  const ADDONS=String(CC.addons||'').split(',').map(s=>s.trim()).filter(Boolean);
  const FEE=VIP.fee||20, CYCLE=VIP.cycle||14;

  /* ---------- Product helpers (Guest / VIP variant pairs) ---------- */
  function pick(handle,tier,key){
    const p=P[handle];if(!p)return null;
    const list=p.v.filter(v=>v.t===tier);
    return list.find(v=>v.k===(key||''))||list.find(v=>!key||v.k===key)||list[0]||p.v[0]||null;
  }
  const pair=(handle,key)=>({g:pick(handle,'g',key),v:pick(handle,'v',key)});
  function variantInfo(id){
    for(const h in P){const v=P[h].v.find(x=>x.id===id);if(v)return {h,v,p:P[h]};}
    return null;
  }

  /* ---------- Toast ---------- */
  let tt;function toast(msg){const t=$('#toast');if(!t)return;t.textContent=msg;t.classList.add('on');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('on'),2200);}

  /* ---------- Delivery promise ---------- */
  const D=CC.delivery||{};
  const dFmt=(iso,long)=>new Date(iso+'T12:00:00').toLocaleDateString('en-US',long?{weekday:'long',month:'long',day:'numeric'}:{weekday:'short',month:'short',day:'numeric'});
  const noDay=s=>s.replace(/^\w+, /,'');
  function deliveryState(){
    const now=new Date();
    const sh=d=>d.toLocaleDateString('en-US',{month:'short',day:'numeric'});
    const from=addBiz(now,D.minDays||1), to=addBiz(now,D.maxDays||2);
    const range=from.toDateString()===to.toDateString()?sh(from):(from.getMonth()===to.getMonth()?sh(from)+'\u2013'+to.getDate():sh(from)+'\u2013'+sh(to));
    const eta='Express shipping. Arrives <b>'+range+'</b>.';
    if(!D.cutoff||!D.by)return {html:eta,rb:'Express shipping \u00b7 arrives in 1\u20132 days',faq:'Every order ships express and arrives in 1 to 2 business days ('+range+').'};
    const cut=new Date(D.cutoff+'T23:59:59');
    const byDay=noDay(dFmt(D.by));
    const guarantee=' <span class="dlv-credit">Guaranteed before '+byDay+(D.lateCredit?', or we add $'+D.lateCredit+' in store credit.':'.')+'</span>';
    const faqOn='Every order ships express and arrives in 1 to 2 business days ('+range+'). Order by '+dFmt(D.cutoff,true)+' and it will get to you by '+dFmt(D.by,true)+'.'+(D.lateCredit?' If an order placed by then arrives after '+noDay(dFmt(D.by,true))+', we add $'+D.lateCredit+' in store credit to your account.':'');
    if(now<=cut){
      const days=Math.ceil((cut-now)/86400000);
      const today=new Date(now.getFullYear(),now.getMonth(),now.getDate()), cutDay=new Date(D.cutoff+'T00:00:00'), cal=Math.round((cutDay-today)/86400000);
      if(days>(D.leadDays||21)) return {html:eta+guarantee, rb:'Guaranteed before '+byDay, faq:faqOn};
      return {html:'Order by <b>'+dFmt(D.cutoff)+'</b> to get it by <b>'+dFmt(D.by)+'</b>.'+(cal<=6?' <span class="dlv-left">'+(cal===0?'Last day to order.':cal===1?'Ends tomorrow.':'Ends in '+cal+' days.')+'</span>':'')+guarantee,
        rb:'Order by '+noDay(dFmt(D.cutoff))+', get it by '+byDay, faq:faqOn};
    }
    return {html:eta, rb:'Express shipping \u00b7 arrives in 1\u20132 days', faq:'The order-by date for '+noDay(dFmt(D.by,true))+' delivery has passed. Every order still ships express and arrives in 1 to 2 business days ('+range+').'};
  }
  const DLV=deliveryState();
  document.querySelectorAll('.dlv-msg').forEach(e=>e.innerHTML=DLV.html);
  document.querySelectorAll('.dlv-rb').forEach(e=>e.textContent=DLV.rb);
  document.querySelectorAll('.dlv-faq').forEach(e=>e.textContent=DLV.faq);
  /* Early-bird guest price: shown until the end date, then hidden (the real price goes up the next day). */
  (function(){
    const EB=CC.earlyBird||{};if(!EB.end||!EB.next)return;
    const els=document.querySelectorAll('.eb-line');if(!els.length)return;
    const now=new Date(), end=new Date(EB.end+'T23:59:59');if(now>end)return;
    const today=new Date(now.getFullYear(),now.getMonth(),now.getDate()), cal=Math.round((new Date(EB.end+'T00:00:00')-today)/86400000);
    const after=addDays(new Date(EB.end+'T12:00:00'),1).toLocaleDateString('en-US',{month:'short',day:'numeric'});
    const left=cal===0?'Ends tonight.':cal===1?'Ends tomorrow.':cal<=6?'Ends in '+cal+' days.':'';
    const html='<b>Early-bird price.</b> Goes up to '+money(EB.next)+' on '+after+'.'+(left?' <span class="dlv-left">'+left+'</span>':'');
    els.forEach(e=>{e.innerHTML=html;e.hidden=false;});
  })();

  /* ---------- Cart API ---------- */
  const R=CC.routes||{};
  const api=(url,body)=>fetch(url,{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body?JSON.stringify(body):undefined,credentials:'same-origin'}).then(async r=>{const j=await r.json().catch(()=>({}));if(!r.ok)throw Object.assign(new Error(j.description||j.message||'Cart error'),{data:j});return j;});
  const getCart=()=>api((R.cart||'/cart')+'.js');
  const addItems=items=>api((R.add||'/cart/add')+'.js',{items});
  const updateCart=body=>api((R.update||'/cart/update')+'.js',body);
  const changeLine=(key,quantity)=>api((R.change||'/cart/change')+'.js',{id:key,quantity});
  let CART=null, notice='', busy=false, leaving=false;
  const isVipLine=i=>i.handle===VIP.handle||(VIP.variant&&i.variant_id===VIP.variant);
  const isProtectLine=i=>PROTECT.variant&&i.variant_id===PROTECT.variant;
  const goods=c=>(c?c.items:[]).filter(i=>!isVipLine(i)&&!isProtectLine(i));
  const hasVip=c=>!!(c&&c.items.some(isVipLine));
  const vipOn=c=>CC.member||hasVip(c);
  /* Shipping protection is a shipping rate ("Standard + Package Protection"), not a cart line. The cart writes the
     attribute protection=yes|no and the castcabin-shipping checkout Function puts the protection rate first on "yes".
     isProtectLine only finds old carts that still hold the retired protection product, so they can be cleaned up. */
  const protAttr=c=>(c&&c.attributes)||{};
  const protectOff=c=>{const a=protAttr(c);return a.protection==='no'||a._cc_protect_off==='1';};
  const protectOn=c=>!!PROTECT.on&&!protectOff(c);
  const protectAttrs=c=>({protection:protectOn(c)?'yes':'no'});
  function setCount(c){const n=goods(c).reduce((a,i)=>a+i.quantity,0);const el=$('#cartCount');if(el)el.textContent=n;return n;}
  async function refresh(){CART=await getCart();setCount(CART);return CART;}

  async function applyVipCode(){
    if(!VIP.code)return;
    try{await updateCart({discount:VIP.code});}catch(e){}
    try{await fetch('/discount/'+encodeURIComponent(VIP.code)+'?redirect=/cart.js',{credentials:'same-origin'});}catch(e){}
  }
  async function ensureMembership(){
    if(CC.member||hasVip(CART)||!VIP.variant)return false;
    const item={id:VIP.variant,quantity:1};if(VIP.plan)item.selling_plan=VIP.plan;
    await addItems([item]);await applyVipCode();return true;
  }
  async function dropMembership(){
    const l=(CART?CART.items:[]).filter(isVipLine);
    for(const i of l){await changeLine(i.key,0);}
  }
  async function ensureProtection(){
    for(const l of (CART?CART.items:[]).filter(isProtectLine)){await changeLine(l.key,0);}
    const want=protectAttrs(CART).protection;
    if(protAttr(CART).protection!==want)await updateCart({attributes:{protection:want}});
  }
  /* Swap every gift in the cart to the other tier (VIP <-> Guest). */
  async function swapTier(toTier){
    const updates={};let changed=false;
    goods(CART).forEach(i=>{
      const info=variantInfo(i.variant_id);if(!info||info.v.t===toTier)return;
      const target=pick(info.h,toTier,info.v.k);if(!target||target.id===i.variant_id)return;
      updates[i.variant_id]=0;updates[target.id]=(updates[target.id]||0)+i.quantity;changed=true;
    });
    if(changed){
      // a variant being removed must not also be added; keep the added count
      await updateCart({updates});
    }
    return changed;
  }

  /* Shop Pay has a direct checkout link; the other wallets sit at the top of checkout. */
  function goCheckout(wallet){
    leaving=true;
    if(wallet==='shop_pay'){location.href='/checkout?payment=shop_pay';return;}
    const f=$('#ccCheckoutForm');if(f)f.submit();else location.href='/checkout';
  }
  /* Wallet sheets only open from Shopify's own button components, and those are sealed, so call the component's click handler directly. */
  function walletEl(wallet){
    const tag=wallet==='apple_pay'?'shopify-apple-pay-button':'shopify-google-pay-button';
    return document.querySelector('#ccExpress '+tag)||document.querySelector(tag);
  }
  function finishExpress(wallet){
    const el=(wallet==='apple_pay'||wallet==='google_pay')?walletEl(wallet):null;
    if(!el){goCheckout(wallet);return true;}
    notice='';render();openCart();return 'drawer';
  }
  /* Safari only opens a wallet sheet inside the tap itself: start it at once, send the add alongside, and hold Shopify's cart read until the add lands. */
  let xpGate=Promise.resolve();
  function sheetNow(el,handle,qty,key){
    if(busy||leaving||!CART||!el||typeof el.handleClick!=='function')return false;
    if(goods(CART).some(i=>{const f=variantInfo(i.variant_id);return f&&f.v.t==='g';}))return false;
    const vv=pick(handle,'v',key);if(!vv||(!CC.member&&!VIP.plan))return false;
    const items=[{id:vv.id,quantity:Math.max(1,qty||1)}];
    if(!CC.member&&!hasVip(CART)&&VIP.variant){const m={id:VIP.variant,quantity:1};if(VIP.plan)m.selling_plan=VIP.plan;items.push(m);}
    const attrs=protectAttrs(CART);
    busy=true;
    xpGate=addItems(items).then(()=>updateCart({attributes:attrs})).catch(e=>{toast(e.message||'Could not add to cart.');});
    xpGate.then(applyVipCode).then(refresh).catch(()=>{}).then(()=>{busy=false;});
    try{
      Promise.resolve(el.dataSource).then(ds=>{
        if(!ds||typeof ds.getInitialCart!=='function'||ds.ccHeld)return;
        const read=ds.getInitialCart.bind(ds);ds.getInitialCart=(...a)=>xpGate.then(()=>read(...a));ds.ccHeld=true;
      }).catch(()=>{});
      el.handleClick({preventDefault(){}});
    }catch(e){}
    return true;
  }

  /* Add a gift (or the calendar). plan: 'vip' | 'once'. key: style value(s) joined by " / ". express: wallet name, skips the drawer. */
  async function addProduct(handle,plan,qty,key,express){
    if(busy||leaving)return;busy=true;
    try{
      await refresh();
      const wantVip=plan==='vip'||CC.member;
      if(wantVip&&!CC.member&&!VIP.plan){toast('VIP is not switched on yet: the VIP Membership product has no membership plan.');return;}
      const had=goods(CART).length>0, wasVip=vipOn(CART);
      if(express&&wantVip&&!CC.member&&!CART.items.length){
        const vv=pick(handle,'v',key);
        if(vv){
          const m={id:VIP.variant,quantity:1};if(VIP.plan)m.selling_plan=VIP.plan;
          const items=[{id:vv.id,quantity:Math.max(1,qty||1)},m];
          await addItems(items);await updateCart({attributes:protectAttrs(CART)});await applyVipCode();await refresh();
          return finishExpress(express);
        }
      }
      const tier=wantVip?'v':'g';
      const v=pick(handle,tier,key)||pick(handle,'g',key);
      if(!v){toast('This item is not available right now.');return;}
      await addItems([{id:v.id,quantity:Math.max(1,qty||1)}]);
      await refresh();
      notice='';
      if(wantVip&&!CC.member){
        await ensureMembership();
        await refresh();
        await swapTier('v');
        if(had&&!wasVip)notice='Your cart switched to VIP prices for every item. One membership was added.';
      }else if(!wantVip&&hasVip(CART)){
        await dropMembership();await refresh();await swapTier('g');
        notice='Your cart switched to guest prices for every item. The VIP membership was removed.';
      }
      await refresh();
      await ensureProtection();
      await refresh();
      if(express)return finishExpress(express);
      const p=P[handle];
      toast((p?p.s:'Item')+' added.'+(wantVip?' VIP price.':''));
      render();openCart();
    }catch(e){toast(e.message||'Could not add to cart.');}
    finally{busy=false;}
  }
  window.ccAdd=addProduct;

  async function switchPlan(){
    if(busy||CC.member)return;busy=true;
    try{
      await refresh();
      if(hasVip(CART)){await dropMembership();await refresh();await swapTier('g');notice='Switched to guest prices for every item. The membership was removed.';}
      else{if(!VIP.plan){toast('VIP is not switched on yet: the VIP Membership product has no membership plan.');return;}await swapTier('v');await refresh();await ensureMembership();notice='Switched to VIP prices for every item. One membership was added.';}
      await refresh();render();
      const x=$('#cartBody [data-act="switch"]');if(x)x.focus();
    }catch(e){toast(e.message||'Could not update the cart.');}
    finally{busy=false;}
  }

  /* ---------- Cart drawer ---------- */
  const drawer=$('#cartDrawer'),scrim=$('#scrim'),body=$('#cartBody'),foot=$('#cartFoot');
  const pageBody=$('#cartPageBody'),pageFoot=$('#cartPageFoot');
  let lastFocus=null;
  const TRUCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  const SHIELD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>';
  const thumb=u=>u?(u+(u.indexOf('?')>-1?'&':'?')+'width=160'):'';

  function draw(bodyEl,footEl){
    if(!bodyEl||!footEl)return;
    const c=CART;bodyEl.innerHTML='';footEl.innerHTML='';
    const items=goods(c);
    if(!items.length){
      bodyEl.innerHTML='<div class="empty"><p>Your cart is empty.</p><a class="btn btn-secondary" href="'+esc(R.all||'/collections/all')+'">Shop all</a></div>';
      return;
    }
    const vip=vipOn(c), n=items.reduce((a,i)=>a+i.quantity,0);
    const today=new Date(), first=addDays(today,CYCLE);
    const sp=document.createElement('div');sp.className='cart-proof';
    sp.innerHTML='<span class="av"><i>D</i><i>M</i><i>P</i></span><span><b>'+esc(CC.rating||'4.7')+' ★</b> from '+esc(CC.reviews||'')+' reviews · Dana, Marcus, Priya and '+esc(CC.reviews||'')+' others already ordered</span>';
    const dl=document.createElement('p');dl.className='dlv dlv-cart';dl.innerHTML=TRUCK+'<span>'+DLV.html+'</span>';
    bodyEl.appendChild(sp);bodyEl.appendChild(dl);
    // Free shipping meter (threshold must match the shipping rate set up in Shopify)
    const shipMin=(+CC.freeShipMin||0)*100;
    const orderSub=goods(c).reduce((a,i)=>a+i.final_line_price,0); // gifts only: protection is a shipping rate, the membership never counts
    const freeShip=!shipMin||orderSub>=shipMin;
    if(shipMin){
      const pct=Math.min(100,Math.round(orderSub/shipMin*100));
      const sm=document.createElement('div');sm.className='ship-meter'+(freeShip?' done':'');
      sm.innerHTML='<p>'+(freeShip?'You get <b>free shipping</b> on this order.':'You are <b>'+money(shipMin-orderSub)+'</b> away from free shipping.')+'</p><span class="sm-bar" aria-hidden="true"><i style="width:'+pct+'%"></i></span>';
      bodyEl.appendChild(sm);
    }
    const qtyHtml=(k,q,label)=>'<div class="qty" role="group" aria-label="'+esc(label)+' quantity"><button type="button" data-act="minus" data-k="'+esc(k)+'" aria-label="Lower quantity">&minus;</button><output>'+q+'</output><button type="button" data-act="plus" data-k="'+esc(k)+'" aria-label="Raise quantity">+</button></div>';
    let sub=0;
    items.forEach(i=>{
      const info=variantInfo(i.variant_id), pr=info?pair(info.h,info.v.k):null;
      const style=info&&info.v.k?info.v.k:'';
      let meta='';
      if(pr&&pr.g&&pr.v&&pr.g.id!==pr.v.id){
        meta=vip?'VIP price: '+money(pr.v.p)+' each (guest price is '+money(pr.g.p)+')':'Guest price: '+money(pr.g.p)+' each';
      }
      sub+=i.final_line_price;
      const li=document.createElement('div');li.className='line-item';
      li.innerHTML='<img src="'+esc(thumb(i.image))+'" alt="">'+
        '<div><div class="li-name">'+esc(i.product_title)+'</div>'+
        (style?'<div class="li-meta">Style: '+esc(style)+'</div>':'')+
        (meta?'<div class="li-meta">'+meta+'</div>':'')+
        '<div class="li-row">'+qtyHtml(i.key,i.quantity,info?info.p.s:i.product_title)+'<span class="li-price money">'+money(i.final_line_price)+'</span></div>'+
        '<div class="li-row"><button class="link-btn" data-act="remove" data-k="'+esc(i.key)+'">Remove</button></div></div>';
      bodyEl.appendChild(li);
    });
    // One-tap add-ons for the gift
    const inCart=h=>items.some(i=>{const x=variantInfo(i.variant_id);return x&&x.h===h;});
    const ads=ADDONS.filter(h=>P[h]&&P[h].a&&!inCart(h));
    if(ads.length){
      const ad=document.createElement('div');ad.className='addons';
      ad.innerHTML='<p class="addons-h">Add to their gift</p><div class="addon-row">'+ads.map(h=>{const p=P[h],pr=pair(h,'');const shown=vip&&pr.v?pr.v.p:(pr.g?pr.g.p:0);return '<div class="addon"><img src="'+esc(p.img||'')+'" alt=""><b>'+esc(p.s)+'</b><span><span class="money">'+money(shown)+'</span>'+(vip&&pr.g&&pr.v&&pr.g.p!==pr.v.p?' <s>'+money(pr.g.p)+'</s>':'')+'</span><button type="button" class="btn btn-secondary addon-btn" data-act="addon" data-h="'+esc(h)+'">+ Add</button></div>';}).join('')+'</div>';
      bodyEl.appendChild(ad);
    }
    const protOn=protectOn(c);
    if(PROTECT.price){
      const pr=document.createElement('label');pr.className='protect';pr.htmlFor=bodyEl.id+'Protect';
      pr.innerHTML='<input type="checkbox" id="'+bodyEl.id+'Protect" data-act="protect"'+(protOn?' checked':'')+'><span class="pr-ic" aria-hidden="true">'+SHIELD+'</span><span class="pr-txt"><b>Shipping protection · '+money(PROTECT.price)+'</b><span>Covers loss, theft and damage in transit. Uncheck to remove.</span></span>';
      bodyEl.appendChild(pr);
    }
    if(notice){const nt=document.createElement('div');nt.className='notice';nt.textContent=notice;bodyEl.appendChild(nt);}
    if(!CC.member){
      const sw=document.createElement('p');sw.className='plan-switch';
      sw.innerHTML='<button class="link-btn" data-act="switch">'+(vip?'Switch everything to guest prices (no membership)':'Switch to VIP prices ($0 membership fee today)')+'</button>';
      bodyEl.appendChild(sw);
    }
    if(vip&&!CC.member){
      const mc=document.createElement('div');mc.className='member-card';
      mc.innerHTML='<h3>VIP membership (1 per buyer)</h3><ul>'+
        '<li><b>Today:</b> $0 for the membership. VIP prices start now.</li>'+
        '<li><b>'+fmtDate(first)+':</b> first $'+FEE+' payment, '+CYCLE+' days after purchase.</li>'+
        '<li>$'+FEE+' every '+CYCLE+' days after that, until you cancel.</li>'+
        '<li>Cancel online anytime, even before the first charge.</li>'+
        (n>1?'<li>More items do not add more membership fees.</li>':'')+
        '</ul>';
      bodyEl.appendChild(mc);
    }
    const prot=protOn?PROTECT.price:0, grand=sub+prot;
    const s=document.createElement('div');s.className='sum';
    s.innerHTML='<div><span>Subtotal</span><span class="money">'+money(sub)+'</span></div>'+
      (protOn?'<div><span>Shipping protection</span><span class="money">'+money(prot)+'</span></div>':'')+
      (freeShip?'<div><span>Shipping</span><span class="free">'+esc(CC.shippingLabel||'FREE')+'</span></div>':'<div class="soft"><span>Shipping</span><span>Calculated at checkout</span></div>')+
      '<div class="grand"><span>Total</span><span class="money">'+money(grand)+'</span></div>'+
      '<p class="sum-note">Taxes calculated at checkout.'+(vip&&!CC.member?' VIP membership: $0 today, then $'+FEE+' every '+(CYCLE%7===0?(CYCLE===7?'week':CYCLE/7+' weeks'):CYCLE+' days')+' starting '+first.toLocaleDateString('en-US',{month:'short',day:'numeric'})+'.':'')+'</p>';
    footEl.appendChild(s);
    const ex=$('#ccExpress');
    if(ex&&ex.children.length&&footEl===foot){ex.hidden=false;footEl.appendChild(ex);}
    const b=document.createElement('button');b.type='button';b.className='btn btn-primary btn-block';b.textContent='Checkout · '+money(grand);
    b.addEventListener('click',()=>{const f=$('#ccCheckoutForm');if(f)f.submit();else location.href='/checkout';});
    footEl.appendChild(b);
  }
  function render(){draw(body,foot);draw(pageBody,pageFoot);}
  // Shopify prints a long subscription-consent note under the express buttons. Keep it, but show the short
  // checkout wording up front and tuck the full note behind "Details".
  (function(){
    const ex=$('#ccExpress');if(!ex)return;
    const sync=()=>{
      const sm=ex.querySelector('small');let line=ex.querySelector('.xp-consent');
      if(!sm){if(line)line.remove();ex.classList.remove('xp-short','xp-open');return;}
      if(line)return;
      line=document.createElement('p');line.className='xp-consent';
      line.innerHTML='By continuing with your payment, you agree to the future charges listed above and the '+
        '<a href="/policies/subscription-policy" target="_blank" rel="noopener">cancellation policy</a>'+
        '. <button type="button" class="link-btn xp-more" aria-expanded="false">Details</button>';
      line.querySelector('.xp-more').addEventListener('click',e=>{
        const on=ex.classList.toggle('xp-open');
        e.currentTarget.setAttribute('aria-expanded',String(on));
        e.currentTarget.textContent=on?'Hide details':'Details';
      });
      const live=ex.querySelector('.express-live');
      if(live)live.insertAdjacentElement('afterend',line);else ex.prepend(line);
      ex.classList.add('xp-short');
    };
    new MutationObserver(sync).observe(ex,{childList:true,subtree:true});
    sync();
  })();

  async function onAct(e){
    const t=e.target.closest('[data-act]');if(!t||busy)return;
    const act=t.dataset.act,k=t.dataset.k;
    if(act==='addon'){e.preventDefault();addProduct(t.dataset.h,vipOn(CART)?'vip':'once',1,'');return;}
    if(act==='switch'){e.preventDefault();switchPlan();return;}
    if(act==='protect'){
      busy=true;
      try{
        for(const l of CART.items.filter(isProtectLine)){await changeLine(l.key,0);}
        await updateCart({attributes:{protection:t.checked?'yes':'no',_cc_protect_off:''}});
        await refresh();render();
        const x=document.getElementById(t.id);if(x)x.focus();
      }catch(err){toast(err.message||'Could not update the cart.');}
      finally{busy=false;}
      return;
    }
    const line=CART&&CART.items.find(i=>i.key===k);if(!line)return;
    e.preventDefault();busy=true;notice='';
    try{
      let q=line.quantity;
      if(act==='plus')q=Math.min(99,q+1);
      if(act==='minus')q=Math.max(0,q-1);
      if(act==='remove'){q=0;toast('Removed from cart.');}
      await changeLine(k,q);await refresh();
      if(!goods(CART).length){
        // empty cart: drop the membership too
        for(const i of CART.items){await changeLine(i.key,0);}
        await refresh();
      }
      render();
      const again=document.querySelector('[data-act="'+act+'"][data-k="'+CSS.escape(k)+'"]');if(again)again.focus();else{const cb=$('#closeCart');if(cb)cb.focus();}
    }catch(err){toast(err.message||'Could not update the cart.');}
    finally{busy=false;}
  }
  if(body)body.addEventListener('click',onAct);
  if(body)body.addEventListener('change',e=>{if(e.target.matches('[data-act="protect"]'))onAct(e);});
  if(pageBody)pageBody.addEventListener('click',onAct);
  if(pageBody)pageBody.addEventListener('change',e=>{if(e.target.matches('[data-act="protect"]'))onAct(e);});
  // checkbox fires click before change; keep only the change for it
  [body,pageBody].forEach(el=>{if(el)el.addEventListener('click',e=>{if(e.target.matches('[data-act="protect"]'))e.stopImmediatePropagation();},true);});

  function openCart(){
    if(!drawer||pageBody)return;
    lastFocus=document.activeElement;
    drawer.classList.add('on');scrim.classList.add('on');drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    updateSticky();
    setTimeout(()=>{const c=$('#closeCart');if(c)c.focus();},30);
  }
  function closeCart(){
    if(!drawer)return;
    drawer.classList.remove('on');scrim.classList.remove('on');drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    updateSticky();
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  const oc=$('#openCart');
  if(oc)oc.addEventListener('click',async e=>{if(pageBody)return;e.preventDefault();notice='';try{await refresh();}catch(err){}render();openCart();});
  const cc=$('#closeCart');if(cc)cc.addEventListener('click',closeCart);
  if(scrim)scrim.addEventListener('click',closeCart);
  document.addEventListener('keydown',e=>{
    if(!drawer||!drawer.classList.contains('on'))return;
    if(e.key==='Escape'){closeCart();return;}
    if(e.key==='Tab'){
      const f=[...drawer.querySelectorAll('button,[href],input,select,textarea,iframe,[tabindex]:not([tabindex="-1"])')].filter(x=>!x.disabled&&x.offsetParent!==null);
      if(!f.length)return;
      const first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  // First load: keep the header count right and draw the cart page if we are on it
  // carts from before protection became a shipping rate may still hold the old protection product: swap it for the attribute
  refresh().then(async()=>{if(CART.items.some(isProtectLine)&&!busy){busy=true;try{await ensureProtection();await refresh();}catch(e){}finally{busy=false;}}if(pageBody)render();}).catch(()=>{});

  /* ---------- Calendar page: gallery, quantity, buy buttons ---------- */
  const calSec=$('[data-cal]');
  const track=$('#track');
  if(track){
    const slides=[...track.children], thumbs=[...document.querySelectorAll('.thumb')], dots=[...($('#dots')||{children:[]}).children];
    let cur=0;
    const setCur=i=>{cur=i;thumbs.forEach((t,k)=>t.setAttribute('aria-current',k===i?'true':'false'));dots.forEach((d,k)=>d.classList.toggle('on',k===i));};
    const goTo=(i,smooth=true)=>{i=(i+slides.length)%slides.length;track.style.scrollBehavior=smooth?'smooth':'auto';track.scrollLeft=slides[i].offsetLeft;setCur(i);};
    thumbs.forEach(t=>t.addEventListener('click',()=>goTo(+t.dataset.i)));
    const pv=$('#prevSlide'),nx=$('#nextSlide');
    if(pv)pv.addEventListener('click',()=>goTo(cur-1));
    if(nx)nx.addEventListener('click',()=>goTo(cur+1));
    track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();goTo(cur+1);}if(e.key==='ArrowLeft'){e.preventDefault();goTo(cur-1);}});
    let st;track.addEventListener('scroll',()=>{clearTimeout(st);st=setTimeout(()=>{const i=Math.round(track.scrollLeft/track.clientWidth);if(i!==cur)setCur(Math.max(0,Math.min(slides.length-1,i)));},80);});
  }
  const sel={qty:1};
  const els={qtyOut:$('#qtyOut'),totalAmt:$('#totalAmt'),totalNote:$('#totalNote'),onceAmt:$('#onceAmt'),vipQtyNote:$('#vipQtyNote'),sPrice:$('#sPrice'),sPlan:$('#sPlan'),sBtn:$('#sBtn'),sticky:$('#sticky'),xpAmt:$('#xpAmt')};
  const calVip=calSec?+calSec.dataset.vip:0, calReg=calSec?+calSec.dataset.reg:0, calHandle=calSec?calSec.dataset.cal:CC.calendar;
  function renderSelection(){
    if(!calSec)return;
    const q=sel.qty, vipTotal=calVip*q, onceTotal=calReg*q;
    if(els.qtyOut)els.qtyOut.value=q;
    if(els.totalAmt)els.totalAmt.textContent=money(vipTotal);
    if(els.totalNote)els.totalNote.textContent=q>1?(q+' x '+money(calVip)):'';
    if(els.onceAmt)els.onceAmt.textContent=money(onceTotal);
    if(els.xpAmt)els.xpAmt.textContent=money(vipTotal);
    if(els.vipQtyNote)els.vipQtyNote.hidden=q<=1||CC.member;
    if(els.sPrice)els.sPrice.textContent=money(vipTotal)+' today';
    if(els.sPlan)els.sPlan.textContent=CC.member?'VIP price, '+q+(q>1?' calendars':' calendar'):'VIP price, '+q+(q>1?' calendars':' calendar')+' (or '+money(onceTotal)+' once)';
  }
  const qm=$('#qtyMinus'),qp=$('#qtyPlus');
  if(qm)qm.addEventListener('click',()=>{sel.qty=Math.max(1,sel.qty-1);renderSelection();});
  if(qp)qp.addEventListener('click',()=>{sel.qty=Math.min(10,sel.qty+1);renderSelection();});
  const bVip=$('#addVipBtn'),bOnce=$('#addOnceBtn');
  if(bVip)bVip.addEventListener('click',()=>addProduct(calHandle,'vip',sel.qty,''));
  if(bOnce)bOnce.addEventListener('click',()=>addProduct(calHandle,'once',sel.qty,''));
  const xpRow=$('#xpVip');
  if(xpRow){
    const xpApple=xpRow.querySelector('[data-xp="apple_pay"]'),xpGoogle=xpRow.querySelector('[data-xp="google_pay"]');
    let onApple=false;try{onApple=!!(window.ApplePaySession&&ApplePaySession.canMakePayments());}catch(e){}
    if(xpApple&&onApple){xpApple.hidden=false;if(xpGoogle)xpGoogle.hidden=true;}
    xpRow.addEventListener('click',async e=>{
      const b=e.target.closest('[data-xp]');if(!b||b.disabled)return;
      if((b.dataset.xp==='apple_pay'||b.dataset.xp==='google_pay')&&sheetNow(walletEl(b.dataset.xp),calHandle,sel.qty,''))return;
      xpRow.classList.add('is-busy');
      const ok=await addProduct(calHandle,'vip',sel.qty,'',b.dataset.xp);
      if(ok!==true)xpRow.classList.remove('is-busy');
    });
    window.addEventListener('pageshow',e=>{if(e.persisted){leaving=false;xpRow.classList.remove('is-busy');}});
  }
  if(els.sBtn)els.sBtn.addEventListener('click',()=>{
    if(els.sticky&&els.sticky.dataset.mode==='link'){location.href=els.sticky.dataset.href;return;}
    addProduct(calHandle,'vip',sel.qty,'');
  });

  /* ---------- Sticky bar ---------- */
  let buyVisible=true, footerVisible=false;
  function updateSticky(){
    if(!els.sticky)return;
    const opt=$('#options');
    const linkMode=els.sticky.dataset.mode==='link';
    const vis=linkMode?(window.scrollY>560):(opt?!buyVisible:false);
    const show=vis&&!footerVisible&&!(drawer&&drawer.classList.contains('on'))&&window.innerWidth<900;
    els.sticky.classList.toggle('on',show);
    els.sticky.setAttribute('aria-hidden',show?'false':'true');
    if(els.sBtn)els.sBtn.tabIndex=show?0:-1;
    document.body.classList.toggle('has-sticky',show);
  }
  if('IntersectionObserver' in window){
    const opt=$('#options');
    if(opt)new IntersectionObserver(en=>{buyVisible=en[0].isIntersecting||en[0].boundingClientRect.top>0;updateSticky();},{threshold:0.05}).observe(opt);
    const ft=$('#footer');
    if(ft)new IntersectionObserver(en=>{footerVisible=en[0].isIntersecting;updateSticky();},{threshold:0.1}).observe(ft);
  }
  window.addEventListener('resize',updateSticky);
  window.addEventListener('scroll',updateSticky,{passive:true});

  /* ---------- Videos: muted autoplay when in view, lazy source, poster fallback ---------- */
  const clips=[...document.querySelectorAll('.vclip')];
  const canAuto=!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fallback(v){
    if(v.dataset.fb||!v.dataset.src)return; v.dataset.fb='1';
    const holder=v.closest('.vframe,.hero-media'); const poster=v.getAttribute('poster');
    if(holder){holder.classList.add('kb');if(poster)holder.style.backgroundImage='url('+poster+')';}
  }
  function tryPlay(v){
    if(v.dataset.fb)return;
    if(!v.getAttribute('src')&&v.dataset.src){v.src=v.dataset.src;}
    const p=v.play();
    if(p&&p.then){p.then(()=>{const h=v.closest('.vframe,.hero-media');if(h)h.classList.add('playing');}).catch(err=>{if(!err||err.name!=='AbortError')fallback(v);});}
    clearTimeout(v._stall); v._stall=setTimeout(()=>{if(!v.dataset.fb&&v.isConnected&&v.readyState===0&&v.networkState!==2)fallback(v);},4000);
  }
  const vio=('IntersectionObserver' in window)?new IntersectionObserver(en=>{en.forEach(e=>{const v=e.target;if(v.dataset.fb)return;if(e.isIntersecting&&canAuto){clearTimeout(v._dt);const d=+(v.dataset.delay||0);if(d){v._dt=setTimeout(()=>tryPlay(v),d);}else{tryPlay(v);}}else{clearTimeout(v._dt);clearTimeout(v._stall);v.pause();}});},{threshold:0.4}):null;
  clips.forEach(v=>{v.addEventListener('error',()=>fallback(v),{once:true});if(vio)vio.observe(v);else if(canAuto)tryPlay(v);});
  if(!canAuto)clips.forEach(v=>fallback(v));

  /* ---------- Reviews: show more ---------- */
  document.querySelectorAll('[id$="moreReviews"]').forEach(btn=>btn.addEventListener('click',()=>{const sec=btn.closest('section');sec.querySelectorAll('.rev.extra').forEach(r=>r.hidden=false);btn.hidden=true;}));

  /* ---------- Motion: reveals, stagger, flips, cart pop ---------- */
  const motionOK=!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(motionOK)document.documentElement.classList.add('motion');
  const flip=el=>{if(!el||!motionOK)return;el.classList.remove('num-flip');void el.offsetWidth;el.classList.add('num-flip');};
  const pop=el=>{if(!el||!motionOK)return;el.classList.remove('pop');void el.offsetWidth;el.classList.add('pop');};
  if(motionOK&&'IntersectionObserver' in window){
    const rio=new IntersectionObserver(en=>{en.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');rio.unobserve(e.target);}});},{threshold:0.15,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.reveal').forEach(el=>rio.observe(el));
    const tables=[...document.querySelectorAll('.cmp-rows')];
    const lightUp=tb=>{if(tb.dataset.done)return;tb.dataset.done='1';[...tb.rows].forEach((x,i)=>setTimeout(()=>x.classList.add('in'),i*140));};
    const tio=new IntersectionObserver(en=>{en.forEach(e=>{if(e.isIntersecting){lightUp(e.target);tio.unobserve(e.target);}});},{threshold:0.3});
    tables.forEach(tb=>tio.observe(tb));
    const sweep=()=>{const H=innerHeight;document.querySelectorAll('.reveal:not(.in)').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<H*0.95&&r.bottom>0)el.classList.add('in');});tables.forEach(tb=>{const r=tb.getBoundingClientRect();if(r.height&&r.top<H*0.9&&r.bottom>0)lightUp(tb);});};
    let sw=false;window.addEventListener('scroll',()=>{if(sw)return;sw=true;requestAnimationFrame(()=>{sweep();sw=false;});},{passive:true});
    setTimeout(sweep,1200);setTimeout(sweep,3500);
  }else{document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));document.querySelectorAll('.cmp-rows tr').forEach(r=>r.classList.add('in'));}
  /* Stat rings: fill and count up when scrolled into view */
  (()=>{
    const rings=[...document.querySelectorAll('.ring')];
    if(!rings.length||!motionOK)return;
    rings.forEach(r=>{const t=parseFloat(getComputedStyle(r).getPropertyValue('--p'))||0;r.dataset.target=t;r.style.setProperty('--p',0);const sp=r.querySelector('span');if(sp)sp.textContent='0%';});
    const run=box=>{if(box.dataset.done)return;box.dataset.done='1';
      box.querySelectorAll('.ring').forEach((r,i)=>{const t=+r.dataset.target, sp=r.querySelector('span'), dur=1400, delay=i*220;
        setTimeout(()=>{const t0=performance.now();const step=now=>{const k=Math.min(1,(now-t0)/dur), e=1-Math.pow(1-k,3), v=t*e;
          r.style.setProperty('--p',v.toFixed(2));if(sp)sp.textContent=Math.round(v)+'%';
          if(k<1)requestAnimationFrame(step);else{r.classList.add('ring-done');}};requestAnimationFrame(step);},delay);});};
    const boxes=[...document.querySelectorAll('.results')];
    const check=()=>{const H=innerHeight;boxes.forEach(b=>{if(b.dataset.done)return;const r=b.getBoundingClientRect();if(r.width&&r.top<H*0.85&&r.bottom>0)run(b);});};
    if('IntersectionObserver' in window){const io=new IntersectionObserver(en=>en.forEach(e=>{if(e.isIntersecting&&e.intersectionRatio>=0.4){run(e.target);io.unobserve(e.target);}}),{threshold:[0.4]});boxes.forEach(b=>io.observe(b));}
    let q=false;window.addEventListener('scroll',()=>{if(q)return;q=true;requestAnimationFrame(()=>{check();q=false;});},{passive:true});
  })();
  document.querySelectorAll('.steps,.trio,.price-cards,.strip,.reviews-grid').forEach(g=>{[...g.children].forEach((c,i)=>{c.style.setProperty('--d',(i%6)*90+'ms');});});
  const flash=(btn,label)=>{if(!btn)return;const old=btn.innerHTML;btn.classList.add('added');btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:20px;height:20px"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> '+label;setTimeout(()=>{btn.classList.remove('added');btn.innerHTML=old;},1300);};
  if(bVip)bVip.addEventListener('click',()=>{flash(bVip,CC.member?'Added to cart':'Added. VIP joined');pop($('#cartCount'));});
  if(bOnce)bOnce.addEventListener('click',()=>{flash(bOnce,'Added to cart');pop($('#cartCount'));});
  if(bOnce){const vb=$('.vip-box');if(vb){bOnce.addEventListener('mouseenter',()=>vb.classList.add('dim'));bOnce.addEventListener('mouseleave',()=>vb.classList.remove('dim'));bOnce.addEventListener('focus',()=>vb.classList.add('dim'));bOnce.addEventListener('blur',()=>vb.classList.remove('dim'));}}
  [qp,qm].forEach(b=>{if(b)b.addEventListener('click',()=>{flip($('#totalAmt'));flip($('#onceAmt'));flip($('#sPrice'));});});

  /* ---------- Video wall arrows ---------- */
  document.querySelectorAll('.vnav-btn').forEach(b=>b.addEventListener('click',()=>{const w=b.closest('section').querySelector('.vids');const c=w.querySelector('.vcard');const step=c?(c.getBoundingClientRect().width+20)*2:300;w.scrollBy({left:step*(+b.dataset.dir),behavior:'smooth'});}));

  /* ---------- Mobile menu ---------- */
  const menuBtn=$('#menuBtn'), menu=$('#mobileMenu');
  if(menuBtn&&menu){
    const setMenu=o=>{menu.hidden=!o;menuBtn.setAttribute('aria-expanded',o?'true':'false');menuBtn.setAttribute('aria-label',o?'Close menu':'Open menu');};
    menuBtn.addEventListener('click',()=>setMenu(menu.hidden));
    menu.querySelectorAll('a').forEach(x=>x.addEventListener('click',()=>setMenu(false)));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!menu.hidden){setMenu(false);menuBtn.focus();}});
  }

  /* ---------- Gift product pages ---------- */
  document.querySelectorAll('[data-gear]').forEach(pg=>{
    let q=1;const out=pg.querySelector('.gq-out'),main=pg.querySelector('.gp-main img');
    const gqm=pg.querySelector('.gq-minus'),gqp=pg.querySelector('.gq-plus');
    if(gqm)gqm.addEventListener('click',()=>{q=Math.max(1,q-1);out.value=q;});
    if(gqp)gqp.addEventListener('click',()=>{q=Math.min(10,q+1);out.value=q;});
    const th=[...pg.querySelectorAll('.gp-thumb')],gd=[...pg.querySelectorAll('.gp-dots i')];let gi=0;
    const show=i=>{if(!th.length||!main)return;gi=(i+th.length)%th.length;main.src=th[gi].dataset.src;th.forEach((x,k)=>{if(k===gi)x.setAttribute('aria-current','true');else x.removeAttribute('aria-current');});gd.forEach((d,k)=>d.classList.toggle('on',k===gi));};
    th.forEach((t,k)=>t.addEventListener('click',()=>show(k)));
    const gp=pg.querySelector('.gp-prev'),gn=pg.querySelector('.gp-next');
    if(gp)gp.addEventListener('click',()=>show(gi-1));
    if(gn)gn.addEventListener('click',()=>show(gi+1));
    const gm=pg.querySelector('.gp-main');let sx=null;
    if(gm){gm.addEventListener('touchstart',e=>{sx=e.touches[0].clientX;},{passive:true});
    gm.addEventListener('touchend',e=>{if(sx===null)return;const dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)show(gi+(dx<0?1:-1));sx=null;},{passive:true});}
    pg.querySelectorAll('[data-add]').forEach(b=>b.addEventListener('click',()=>{
      const key=[...pg.querySelectorAll('.gp-opts')].map(fs=>{const c=fs.querySelector('input:checked');return c?c.value:'';}).filter(Boolean).join(' / ');
      addProduct(b.dataset.add,b.dataset.plan,q,key);
      flash(b,b.dataset.plan==='vip'&&!CC.member?'Added. VIP joined':'Added to cart');pop($('#cartCount'));
    }));
  });

  /* ---------- Shop All filters ---------- */
  document.querySelectorAll('.chips .chip').forEach(c=>c.addEventListener('click',()=>{
    const f=c.dataset.filter;document.querySelectorAll('.chips .chip').forEach(x=>{x.classList.toggle('on',x===c);x.setAttribute('aria-pressed',x===c?'true':'false');});
    document.querySelectorAll('#sgrid .scard').forEach(k=>{k.hidden=!(f==='all'||k.dataset.cat===f);});
  }));

  /* ---------- Cancel form: friendly check before it is sent ---------- */
  const cxf=$('#cancelForm');
  if(cxf)cxf.addEventListener('submit',e=>{const m=$('#cancelMsg'),em=$('#cxEmail');
    if(em&&(!em.value||!em.checkValidity())){e.preventDefault();if(m){m.hidden=false;m.className='form-msg err';m.textContent='Please enter the email you used at checkout.';}em.focus();}});

  renderSelection();updateSticky();
})();
